/** A labelled control in the step form, with an optional hint and a red * when it is required
 *  (what readiness blocks on is required on the form too). Shared by every step-type form.
 *
 *  2026-10-14 (step panel redesign) · the hint is HELP: shown under the label only while the panel's
 *  "Show help" is on (HelpContext), and not at all otherwise — no ⓘ on every field. */
import React, { createContext, useContext, useId } from "react";

/** Whether the step panel is showing its help text. Provided by StepForm. */
export const HelpContext = createContext(false);
export const useHelp = () => useContext(HelpContext);

/** Text that is explanation, not input: rendered only while help is on. */
export function HelpText({ children, style }) {
  const on = useHelp();
  if (!on || !children) return null;
  return <div className="u0-help" style={style}>{children}</div>;
}

// A <div role="group">, not a <label>: a label hands every click inside it to its first control a
// second time, so an antd Select in one opened and shut again at once and nothing could be chosen
// (Material type, Who may give it …). The group is named by its label text for screen readers.
export function Field({ label, hint, required = false, children }) {
  const id = useId();
  const help = useHelp();
  return (
    <div className="u0-field" role="group" aria-labelledby={id}>
      <span className="l" id={id}>
        {label}
        {required ? <span className="u0-req" aria-label="required"> *</span> : null}
      </span>
      {hint && help ? <span className="u0-help">{hint}</span> : null}
      {/* The control, in its own box: the step panel lays label and value side by side. */}
      <div className="c">{children}</div>
    </div>
  );
}
